import React, { useEffect, useCallback, useContext } from 'react';
import { useIntl } from 'umi';
import styles from './index.less?modules';
import { Paper } from '@/components/paper/Paper';
import Card from '@material-ui/core/Card';
import classnames from 'classnames';
import PieAge from './components/pieAge/Pie';
import PieGender from './components/pieGender/Pie';
import Level from './components/level/Level';
import Source from './components/source/Source';
import SourceArea from './components/sourceArea/Source';
import Order from './components/order/Order';
import Visit from './components/visit/Visit';
import Point from './components/point/Point';
import AcUsr from './components/active_user_trend/AcUsr';
import NumbersTrend from './components/numbers_trend/NumbersTrend';
import NumbersInfoList from './components/numbersinfo_list/NumbersInfoList';
import { useDispatch, useSelector } from 'dva';
import { BrandContext } from '@/contexts/ContextProviders';
// import Time from '@/assets/icons/time.svg';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
// import dayjs from 'dayjs';

// 消费能力分布的类目顺序是固定值，提到模块级保证引用稳定，
// 否则每次渲染都会让 Source 图表重建 option 并重绘
const CONSUMPTION_CATEGORY_ORDER = ['999以下', '1000-7999', '8000以上'];

const HomePage = () => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const brandContext = useContext(BrandContext);
  // const [dictData, setDictData] = useState([]);
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const {
    chart1Data,
    chart2Data,
    chart3Data,
    chart4Data,
    chart6Data,
    chart7Data,
    chart8Data,
    chart9Data,
    chart10Data,
    chart11Data,
    chart12Data,
    chart13Data,
  } = useSelector((state) => state.dashbord);
  const loading1 = loadingEffect.effects['dashbord/getStatistics'];
  const loading2 = loadingEffect.effects['dashbord/getOrder'];
  const loading3 = loadingEffect.effects['dashbord/getPoint'];
  const loading4 = loadingEffect.effects['dashbord/getAge'];
  const loading6 = loadingEffect.effects['dashbord/getActiveUser'];
  const loading7 = loadingEffect.effects['dashbord/getGrade'];
  const loading8 = loadingEffect.effects['dashbord/getCount'];
  const loading9 = loadingEffect.effects['dashbord/getPointDistribution'];
  const loading10 = loadingEffect.effects['dashbord/getGenderDistribution'];
  const loading11 = loadingEffect.effects['dashbord/getMiniAppAccess'];
  const loading12 =
    loadingEffect.effects['dashbord/getConsumptionDistribution'];
  const loading13 = loadingEffect.effects['dashbord/getRegionDistribution'];

  const loadData = useCallback(() => {
    //会员整体变化
    dispatch({
      type: 'dashbord/getStatistics',
      payload: {},
    });
    //订单金额趋
    dispatch({
      type: 'dashbord/getOrder',
      payload: {},
    });
    //积分增长、消耗趋势
    dispatch({
      type: 'dashbord/getPoint',
      payload: {},
    });
    //年龄分布
    dispatch({
      type: 'dashbord/getAge',
      payload: {},
    });
    //来源分布
    // dispatch({
    //   type: 'dashbord/getSource',
    //   payload: {},
    // });
    //活跃会员
    dispatch({
      type: 'dashbord/getActiveUser',
      payload: {},
    });
    //等级分布
    dispatch({
      type: 'dashbord/getGrade',
      payload: {},
    });
    //会员变化趋势
    dispatch({
      type: 'dashbord/getCount',
      payload: {},
    });
    //积分持有分布
    dispatch({
      type: 'dashbord/getPointDistribution',
      payload: {},
    });
    //性别分布
    dispatch({
      type: 'dashbord/getGenderDistribution',
      payload: {},
    });
    //小程序整体访问
    dispatch({
      type: 'dashbord/getMiniAppAccess',
      payload: {},
    });
    //查询消费能力分布报表
    dispatch({
      type: 'dashbord/getConsumptionDistribution',
      payload: {},
    });
    //查询地域分布报表
    dispatch({
      type: 'dashbord/getRegionDistribution',
      payload: {},
    });
  }, [dispatch]);
  useEffect(() => {
    loadData();
  }, [loadData, brandContext]);

  const times = formatMessage({ id: 'report.newpurchased.n01.lbl01' });

  return (
    <>
      <div
        className={styles.box}
        data-log={JSON.stringify({
          oid: 'page_member_index_dashboard_details',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <div className={styles.title}>
          {/* Here's what's happening */}
          <span className={styles.updateTime}>
            <SvgIconML name={'time'} className={styles.timeSvg}></SvgIconML>
            {/* report.newpurchased.n01.lbl01 */}
            {/* {times}：{dayjs(new Date()).format('YYYY-MM-DD HH:mm')} */}
            {times}：{formatMessage({ id: 'report.newpurchased.n01.lbl02' })}
            {/* 数据截止时间：{dayjs(data.updateDate).format('YYYY-MM-DD HH:mm')} */}
          </span>
        </div>
        <div className={styles.r1}>
          <div className={classnames(styles.r1_c1)}>
            {/* 会员整体变化 */}
            <div className={classnames(styles.r1_c1_r1, styles.chart)}>
              <Paper>
                <NumbersInfoList data={chart1Data} loading={loading1} />
              </Paper>
            </div>
            {/* 会员变化趋势 */}
            <div className={classnames(styles.r1_c1_r2, styles.chart)}>
              <Card style={{ height: '100%' }}>
                <NumbersTrend
                  title={'ec.dashboard.n02.lbl01'}
                  data={chart8Data}
                  loading={loading8}
                />
              </Card>
            </div>
          </div>
          <div className={styles.r1_c2}>
            {/* 年龄分布 */}
            <div className={classnames(styles.r1_c2_r1, styles.chart)}>
              <Card style={{ height: '100%' }}>
                <PieAge
                  boxId={'ec.dashboard.n03.lbl01'}
                  data={chart4Data}
                  loading={loading4}
                />
              </Card>
            </div>
            {/* 性别分布 */}
            <div className={classnames(styles.r1_c2_r2, styles.chart)}>
              <Card style={{ height: '100%' }}>
                <PieGender
                  boxId={'ec.dashboard.new01.lbl01'}
                  data={chart10Data}
                  loading={loading10}
                />
              </Card>
            </div>
          </div>
        </div>

        {/* 24小时活跃会员数 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <AcUsr
                  title={'ec.dashboard.n06.lbl01'}
                  data={chart6Data}
                  loading={loading6}
                />
              </Card>
            </div>
          </div>
        </div>

        {/* 订单趋势 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <Order
                  title={'ec.dashboard.n07.lbl01'}
                  data={chart2Data}
                  loading={loading2}
                />
              </Card>
            </div>
          </div>
        </div>

        {/* 积分变化趋势 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <Point
                  title={'ec.dashboard.n08.lbl01'}
                  data={chart3Data}
                  loading={loading3}
                />
              </Card>
            </div>
          </div>
        </div>

        {/* 小程序整体访问 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <Visit
                  title={'ec.dashboard.new01.lbl04'}
                  data={chart11Data}
                  loading={loading11}
                />
              </Card>
            </div>
          </div>
        </div>

        {/* 等级分布 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <Level data={chart7Data} loading={loading7} />
              </Card>
            </div>
          </div>
        </div>

        {/* 消费能力分布 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <Source
                  boxId={'ec.dashboard.new01.lbl03'}
                  categoryOrder={CONSUMPTION_CATEGORY_ORDER}
                  data={chart12Data}
                  loading={loading12}
                />
              </Card>
            </div>
          </div>
        </div>

        {/* 积分持有分布 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <Source
                  boxId={'ec.dashboard.new01.lbl05'}
                  data={chart9Data}
                  loading={loading9}
                />
              </Card>
            </div>
          </div>
        </div>

        {/* 地域分布 */}
        <div className={styles.chart_box}>
          <div style={{ display: 'flex' }}>
            <div className={classnames(styles.chart)} style={{ flex: 1 }}>
              <Card style={{ height: '100%' }}>
                <SourceArea
                  boxId={'ec.dashboard.new01.lbl02'}
                  data={chart13Data}
                  loading={loading13}
                />
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default HomePage;
